import { Component, Input } from '@angular/core';

import { UserNavbarItem } from '@common/models/navbar-item';

@Component({
    selector: 'aa-dash-appli-container',
    templateUrl: './dash-appli-container.component.html',
    styleUrls: [
        './dash-appli-container.component.scss'
    ],
    standalone: false
})
export class DashAppliContainerComponent
{
    @Input() userNavbarItem: UserNavbarItem;
}
